import * as React from "react";
import { quotationFormStyles } from "./QuotationForm.styles";
import { UiFormBuilder } from "../../utils/UiFormBuilder";
import { WithStyles, Tooltip, IconButton } from "@material-ui/core";
import { UpdateRequestBuilder } from "../../utils/UpdateRequestBuilder";
import { Form } from "../../types/Form";
import InfoOutlineIcon from "@material-ui/icons/InfoOutline";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import InputDate from "../InputDate/InputDate";
import { Quotation } from "../../types/Quotation";
import { Customer } from "../../types/Customer";

interface QuotationFormDateProps extends WithStyles<typeof quotationFormStyles> {
    productName: string;
    customer: Customer;
    quotation: Quotation;
    getAgeAtDate(birthdate: string, date: string): number;
    onChange(dateOfValidity: string);
}

type QuotationFormDateState = {
    form: Form<any>;
};
class QuotationFormDate extends React.Component<QuotationFormDateProps, QuotationFormDateState> {

    private formBuilder = null;
    
    /**
     *
     */
    componentWillMount() {
        this.updateState(this.props);
    }

    /**
     * 
     */
    componentWillReceiveProps(nextProps: QuotationFormDateProps) {
        this.updateState(nextProps);
    }

    /**
     * 
     * @param fieldName 
     * @param value 
     * @param element 
     */
    public onChange(fieldName: string, value: any, element: any) {
        const builder = new UpdateRequestBuilder();
        builder.set(`values.${fieldName}`, value);
        let form = builder.exec(this.state.form);
        this.setState({ form: form });
        this.props.onChange(value);
    }

    /**
     * 
     */
    public render() {
        if (!this.state) {
            return null;
        }
        const uiForm = this.formBuilder.build(this.state.form);
        return (
            <div className={this.props.classes.box}>
                <Typography variant="title" gutterBottom={true} className={this.props.classes.formTitle}>3/ Date d'effet souhaitée</Typography>
                <Grid container={true} spacing={16}>
                    <Grid item={true} sm={4}>
                        <InputDate {...uiForm.fields.effectiveDate} />
                    </Grid>
                    {this.props.quotation.effectiveDate && this.props.customer && this.props.customer.birthdate ?
                        <Grid item={true} sm={12}>
                            <Typography variant="body1" gutterBottom={true}>
                                <i>Âge de l'adhérent à la date d'effet souhaitée :</i> <b>{this.getAgeAtDate(this.props.customer.birthdate, this.props.quotation.effectiveDate)} ans</b>
                                <Tooltip
                                    enterDelay={300}
                                    id="tooltip-controlled"
                                    leaveDelay={300}
                                    placement="bottom"
                                    title={<div>Le premier jour du mois en cours ou le premier jour du mois suivant l'adhesion.<br />
                                        Ex: Si je souscris le 14/09/XXXX, je peux mettre une date d'effet au 01/09/XXXX.<br />
                                        Si je souscris après le 15/09/XXXX, je suis obligé de mettre une date au 01/10/XXXX.</div>}
                                >
                                    <IconButton aria-label="Delete" style={{ width: "18px", height: "18px", marginTop: "-10px" }}>
                                        <InfoOutlineIcon style={{ fontSize: 12 }} />
                                    </IconButton>
                                </Tooltip>
                            </Typography>
                        </Grid>
                        : null}
                </Grid>
            </div>
        );
    }

    /**
     * 
     */
    private updateState(props: QuotationFormDateProps) {
        this.formBuilder = new UiFormBuilder<string>();
        this.formBuilder
            .addField("effectiveDate", {
                props: {
                    label: "Date d’effet souhaitée",
                    placeholder: "Saisir la date",
                    legend: "Le tarif peut évoluer au mois anniversaire de l'assuré",
                    required: true,
                    /*
                    dateProps: {
                        min: moment().format("YYYY-MM-DD"),
                        max: moment().add(100, "year").format("YYYY-MM-DD")
                    }
                    */
                }
            })
            .onChange(this.onChange.bind(this))
            ;
        this.setState({
            form: {
                fields: {},
                errors: [],
                values: { effectiveDate: props.quotation.effectiveDate }
            }
        });
    }

    private getAgeAtDate(birthdate: string, date: string): number {
        if (this.props.getAgeAtDate) return this.props.getAgeAtDate(birthdate, date);
        return 0;
    }
}

export default QuotationFormDate;


// WEBPACK FOOTER //
// ./src/components/QuotationForm/QuotationFormDate.tsx